/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {MetricGoal} from '../../../types';

export const mapMetricGoalsToTableData = (metricGoals: MetricGoal[]): TanStackTableData[] => {
  return metricGoals.map(goal => ({
    metricId: goal.metricId,
    metricName: goal.metricName,
    goalId: goal.goalId,
    goalName: goal.goalName,
  }));
};

